"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HighChartsRenderer = exports.renderLegend = exports.renderChart = exports.FLUID_LEGEND_THRESHOLD = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2018 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var uuid_1 = require("uuid");
var set_1 = tslib_1.__importDefault(require("lodash/set"));
var isEqual_1 = tslib_1.__importDefault(require("lodash/isEqual"));
var noop_1 = tslib_1.__importDefault(require("lodash/noop"));
var partial_1 = tslib_1.__importDefault(require("lodash/partial"));
var throttle_1 = tslib_1.__importDefault(require("lodash/throttle"));
var isNil_1 = tslib_1.__importDefault(require("lodash/isNil"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var Chart_1 = require("./Chart");
var common_1 = require("../chartTypes/_util/common");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var helpers_1 = require("../chartTypes/_chartCreators/helpers");
var sdk_ui_vis_commons_1 = require("@gooddata/sdk-ui-vis-commons");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var mess_1 = require("../typings/mess");
/**
 * @internal
 */
exports.FLUID_LEGEND_THRESHOLD = 768;
function renderChart(props) {
    return react_1.default.createElement(Chart_1.Chart, tslib_1.__assign({}, props));
}
exports.renderChart = renderChart;
function renderLegend(props) {
    return react_1.default.createElement(sdk_ui_vis_commons_1.Legend, tslib_1.__assign({}, props));
}
exports.renderLegend = renderLegend;
var HighChartsRenderer = /** @class */ (function (_super) {
    tslib_1.__extends(HighChartsRenderer, _super);
    function HighChartsRenderer(props) {
        var _this = _super.call(this, props) || this;
        _this.highchartsRendererRef = react_1.default.createRef(); // whole component = legend + chart
        _this.containerId = "visualization-" + uuid_1.v4();
        _this.onWindowResize = function () {
            _this.setState({
                showFluidLegend: _this.shouldShowFluid(),
            });
            _this.realignPieOrDonutChart();
        };
        _this.throttledOnWindowResize = throttle_1.default(_this.onWindowResize, 100);
        // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
        _this.onLegendItemClick = function (item) {
            _this.setState({
                legendItemsEnabled: set_1.default(tslib_1.__spreadArrays(_this.state.legendItemsEnabled), item.legendIndex, !_this.state.legendItemsEnabled[item.legendIndex]),
            });
        };
        _this.setChartRef = function (chartRef) {
            _this.chartRef = chartRef;
        };
        // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
        _this.onChartSelection = function (event) {
            var chartWrapper = event.target.renderTo.parentElement;
            var resetZoomButton = chartWrapper.closest(".visualization").querySelector(".viz-zoom-out");
            if (event.resetSelection) {
                resetZoomButton.style.display = "none";
            }
            else {
                resetZoomButton.style.display = "block";
            }
            return undefined;
        };
        _this.onZoomOutButtonClick = function () {
            _this.chartRef.getChart().zoomOut();
        };
        _this.state = {
            legendItemsEnabled: [],
            showFluidLegend: _this.shouldShowFluid(),
        };
        return _this;
    }
    HighChartsRenderer.prototype.shouldShowFluid = function () {
        var _a = this.props, documentObj = _a.documentObj, legend = _a.legend;
        return (documentObj.documentElement.clientWidth < exports.FLUID_LEGEND_THRESHOLD &&
            (legend === null || legend === void 0 ? void 0 : legend.responsive) !== "autoPositionWithPopup");
    };
    HighChartsRenderer.prototype.UNSAFE_componentWillMount = function () {
        this.resetLegendState(this.props);
    };
    HighChartsRenderer.prototype.componentDidMount = function () {
        var _this = this;
        // http://stackoverflow.com/questions/18240254/highcharts-width-exceeds-container-div-on-first-load
        setTimeout(function () {
            if (_this.chartRef) {
                var chart = _this.chartRef.getChart();
                if (chart.container && chart.container.style) {
                    chart.container.style.height = (_this.props.height && String(_this.props.height)) || "100%";
                    chart.container.style.position = _this.props.height ? "relative" : "absolute";
                    chart.reflow();
                }
            }
        }, 0);
        this.props.onLegendReady({
            legendItems: this.getItems(this.props.legend.items),
        });
        window.addEventListener("resize", this.throttledOnWindowResize);
    };
    HighChartsRenderer.prototype.componentWillUnmount = function () {
        this.throttledOnWindowResize.cancel();
        window.removeEventListener("resize", this.throttledOnWindowResize);
    };
    HighChartsRenderer.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        var _a, _b, _c, _d;
        var thisLegendItems = (_b = (_a = this.props.legend) === null || _a === void 0 ? void 0 : _a.items) !== null && _b !== void 0 ? _b : [];
        var nextLegendItems = (_d = (_c = nextProps.legend) === null || _c === void 0 ? void 0 : _c.items) !== null && _d !== void 0 ? _d : [];
        var hasLegendChanged = !isEqual_1.default(thisLegendItems, nextLegendItems);
        if (hasLegendChanged) {
            this.resetLegendState(nextProps);
        }
        if (!isEqual_1.default(this.props.legend.items, nextProps.legend.items)) {
            this.props.onLegendReady({
                legendItems: this.getItems(nextProps.legend.items),
            });
        }
    };
    HighChartsRenderer.prototype.getFlexDirection = function (position) {
        if (position === mess_1.TOP || position === mess_1.BOTTOM) {
            return "column";
        }
        return "row";
    };
    HighChartsRenderer.prototype.getItems = function (items) {
        var _this = this;
        return items.map(function (i) {
            return {
                name: i.name,
                color: i.color,
                onClick: partial_1.default(_this.onLegendItemClick, i),
            };
        });
    };
    HighChartsRenderer.prototype.resetLegendState = function (props) {
        var _a, _b, _c;
        var legendItemsCount = (_c = (_b = (_a = props.legend) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0;
        this.setState({
            legendItemsEnabled: new Array(legendItemsCount).fill(true),
        });
    };
    HighChartsRenderer.prototype.createChartConfig = function (chartConfig, legendItemsEnabled) {
        var _a, _b;
        var series = chartConfig.series, chart = chartConfig.chart, xAxis = chartConfig.xAxis, yAxis = chartConfig.yAxis;
        var selectionEvent = chart.zoomType
            ? {
                selection: this.onChartSelection,
            }
            : {};
        var firstSeriesTypes = [
            sdk_ui_1.VisualizationTypes.PIE,
            sdk_ui_1.VisualizationTypes.DONUT,
            sdk_ui_1.VisualizationTypes.TREEMAP,
        ];
        var multipleSeries = common_1.isOneOfTypes(chart.type, firstSeriesTypes);
        var items = common_1.isOneOfTypes(chart.type, firstSeriesTypes) ? (_a = series === null || series === void 0 ? void 0 : series[0]) === null || _a === void 0 ? void 0 : _a.data : series;
        var updatedItems = items.map(function (item, itemIndex) {
            var visible = legendItemsEnabled[itemIndex] !== undefined ? legendItemsEnabled[itemIndex] : true;
            return tslib_1.__assign(tslib_1.__assign({}, item), { visible: isNil_1.default(item.visible) ? visible : item.visible });
        });
        var updatedSeries = updatedItems;
        if (multipleSeries) {
            updatedSeries = tslib_1.__spreadArrays([
                tslib_1.__assign(tslib_1.__assign({}, series === null || series === void 0 ? void 0 : series[0]), { data: updatedItems })
            ], series.slice(1));
        }
        return tslib_1.__assign(tslib_1.__assign({}, chartConfig), { chart: tslib_1.__assign(tslib_1.__assign({}, chartConfig === null || chartConfig === void 0 ? void 0 : chartConfig.chart), { events: tslib_1.__assign(tslib_1.__assign({}, (_b = chartConfig === null || chartConfig === void 0 ? void 0 : chartConfig.chart) === null || _b === void 0 ? void 0 : _b.events), selectionEvent) }), series: updatedSeries, yAxis: yAxis.map(function (ax) {
                var _a;
                return (tslib_1.__assign(tslib_1.__assign({}, ax), { title: tslib_1.__assign(tslib_1.__assign({}, ax === null || ax === void 0 ? void 0 : ax.title), { style: tslib_1.__assign(tslib_1.__assign({}, (_a = ax === null || ax === void 0 ? void 0 : ax.title) === null || _a === void 0 ? void 0 : _a.style), { textOverflow: "ellipsis", overflow: "hidden" }) }) }));
            }), 
            // perform a shallow copy of axis
            // (otherwise there's a highcharts internal error on smallest responsive charts)
            xAxis: xAxis.map(function (ax) { return (tslib_1.__assign({}, ax)); }) });
    };
    HighChartsRenderer.prototype.renderLegend = function (legendDetails, contentRect, containerId) {
        var _a = this.props, chartOptions = _a.chartOptions, legend = _a.legend, height = _a.height, legendRenderer = _a.legendRenderer, locale = _a.locale;
        var items = legend.items, format = legend.format;
        var showFluidLegend = this.state.showFluidLegend;
        if (!legend.enabled) {
            return null;
        }
        var type = chartOptions.type;
        if (common_1.isPieOrDonutChart(type)) {
            type = sdk_ui_1.VisualizationTypes.PIE;
        }
        var legendProps = {
            responsive: legend.responsive,
            enableBorderRadius: legend.enableBorderRadius,
            seriesMapper: legend.seriesMapper,
            series: items,
            onItemClick: this.onLegendItemClick,
            legendItemsEnabled: this.state.legendItemsEnabled,
            heatmapLegend: common_1.isHeatmap(type),
            height: height,
            legendLabel: legendDetails === null || legendDetails === void 0 ? void 0 : legendDetails.name,
            maximumRows: legendDetails === null || legendDetails === void 0 ? void 0 : legendDetails.maxRows,
            position: legendDetails.position,
            format: format,
            locale: locale,
            showFluidLegend: showFluidLegend,
            validateOverHeight: noop_1.default,
            contentDimensions: contentRect === null || contentRect === void 0 ? void 0 : contentRect.client,
            containerId: containerId,
        };
        return legendRenderer(legendProps);
    };
    HighChartsRenderer.prototype.renderHighcharts = function () {
        // shrink chart to give space to legend items
        var style = { flex: "1 1 auto", position: "relative", overflow: "hidden" };
        var config = this.createChartConfig(this.props.hcOptions, this.state.legendItemsEnabled);
        var chartProps = {
            domProps: { className: "viz-react-highchart-wrap gd-viz-highchart-wrap", style: style },
            ref: this.setChartRef,
            config: config,
            callback: this.props.afterRender,
        };
        return this.props.chartRenderer(chartProps);
    };
    HighChartsRenderer.prototype.renderZoomOutButton = function () {
        var _a, _b;
        var _c = this.props, chart = _c.hcOptions.chart, theme = _c.theme, resetZoomButtonTooltip = _c.resetZoomButtonTooltip;
        if (chart && chart.zoomType) {
            return (react_1.default.createElement(sdk_ui_kit_1.BubbleHoverTrigger, { tagName: "abbr", hideDelay: 100, showDelay: 100, className: "gd-bubble-trigger-zoom-out" },
                react_1.default.createElement("button", { className: "viz-zoom-out s-zoom-out", onClick: this.onZoomOutButtonClick, style: { display: "none" } },
                    react_1.default.createElement(sdk_ui_kit_1.Icon.Undo, { width: 20, height: 20, color: (_b = (_a = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _a === void 0 ? void 0 : _a.complementary) === null || _b === void 0 ? void 0 : _b.c7 })),
                react_1.default.createElement(sdk_ui_kit_1.Bubble, { alignPoints: [{ align: "cr cl" }, { align: "cl cr" }] }, resetZoomButtonTooltip)));
        }
        return null;
    };
    HighChartsRenderer.prototype.renderVisualization = function () {
        var _a;
        var _b = this.props, legend = _b.legend, chartOptions = _b.chartOptions, contentRect = _b.contentRect;
        var legendDetailOptions = {
            showFluidLegend: this.state.showFluidLegend,
            contentRect: contentRect,
            isHeatmap: common_1.isHeatmap(chartOptions.type),
            legendLabel: chartOptions.legendLabel,
        };
        var legendDetails = sdk_ui_vis_commons_1.getLegendDetails(legend.position, legend.responsive, legendDetailOptions);
        if (!legendDetails) {
            return null;
        }
        var classes = classnames_1.default("viz-line-family-chart-wrap", "s-viz-line-family-chart-wrap", legend.responsive === true ? "responsive-legend" : "non-responsive-legend", (_a = {},
            _a["flex-direction-" + this.getFlexDirection(legendDetails.position)] = true,
            _a["legend-position-bottom"] = legendDetails.position === mess_1.BOTTOM,
            _a), this.containerId);
        var legendPosition = legendDetails.position;
        var isLegendRenderedFirst = legendPosition === mess_1.TOP || legendPosition === mess_1.LEFT || this.state.showFluidLegend;
        return (react_1.default.createElement("div", { className: classes, ref: this.highchartsRendererRef },
            this.renderZoomOutButton(),
            isLegendRenderedFirst && this.renderLegend(legendDetails, contentRect, this.containerId),
            this.renderHighcharts(),
            !isLegendRenderedFirst && this.renderLegend(legendDetails, contentRect, this.containerId)));
    };
    HighChartsRenderer.prototype.render = function () {
        return this.renderVisualization();
    };
    HighChartsRenderer.prototype.realignPieOrDonutChart = function () {
        var _a = this.props.chartOptions, type = _a.type, verticalAlign = _a.verticalAlign;
        var chartRef = this.chartRef;
        if (common_1.isPieOrDonutChart(type) && chartRef) {
            helpers_1.alignChart(chartRef.getChart(), verticalAlign);
        }
    };
    HighChartsRenderer.defaultProps = {
        afterRender: noop_1.default,
        height: null,
        legend: {
            enabled: true,
            responsive: false,
            position: mess_1.RIGHT,
        },
        chartRenderer: renderChart,
        legendRenderer: renderLegend,
        onLegendReady: noop_1.default,
        documentObj: document,
    };
    return HighChartsRenderer;
}(react_1.default.PureComponent));
exports.HighChartsRenderer = HighChartsRenderer;
//# sourceMappingURL=HighChartsRenderer.js.map